// import { call, put, takeLatest } from "redux-saga/effects";
// import { actions, types } from "./duck";

// import {
//   getEmailTemplates,
//   createEmailTemplate,
//   updateEmailTemplate,
//   sendTestEmail,
// } from "./api";

// import { OK, CREATED } from "http-status-codes";
// import { safeResolveAsync } from "../../../utils";

// /* =========================
//    GET EMAIL TEMPLATES
// ========================= */

// function* getEmailTemplatesSaga({ resolve }) {
//   try {
//     yield put(actions.getEmailTemplatesRequest());

//     const response = yield call(getEmailTemplates);

//     if (response.status === OK) {
//       yield put(actions.getEmailTemplatesSuccess(response.data));

//       yield safeResolveAsync(resolve, {
//         success: true,
//         data: response.data,
//       });
//     } else {
//       const error =
//         response.statusText || "Failed to fetch email templates";

//       yield put(actions.getEmailTemplatesFailure(error));

//       yield safeResolveAsync(resolve, {
//         success: false,
//         error,
//       });
//     }
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.error ||
//       error.message ||
//       "Something went wrong";

//     yield put(actions.getEmailTemplatesFailure(errorMessage));

//     yield safeResolveAsync(resolve, {
//       success: false,
//       error: errorMessage,
//     });
//   }
// }

// /* =========================
//    CREATE EMAIL TEMPLATE
// ========================= */

// function* createEmailTemplateSaga({ payload, resolve }) {
//   try {
//     yield put(actions.createEmailTemplateRequest());

//     const response = yield call(
//       createEmailTemplate,
//       payload
//     );

//     if (response.status === CREATED || response.status === OK) {
//       yield put(
//         actions.createEmailTemplateSuccess(response.data)
//       );

//       yield safeResolveAsync(resolve, {
//         success: true,
//         data: response.data,
//       });
//     } else {
//       const error =
//         response.statusText || "Failed to create email template";

//       yield put(actions.createEmailTemplateFailure(error));

//       yield safeResolveAsync(resolve, {
//         success: false,
//         error,
//       });
//     }
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.error ||
//       error.message ||
//       "Something went wrong";

//     yield put(actions.createEmailTemplateFailure(errorMessage));

//     yield safeResolveAsync(resolve, {
//       success: false,
//       error: errorMessage,
//     });
//   }
// }

// /* =========================
//    UPDATE EMAIL TEMPLATE
// ========================= */

// function* updateEmailTemplateSaga({
//   id,
//   payload,
//   resolve,
// }) {
//   try {
//     yield put(actions.updateEmailTemplateRequest());

//     const response = yield call(
//       updateEmailTemplate,
//       id,
//       payload
//     );

//     if (response.status === OK) {
//       yield put(
//         actions.updateEmailTemplateSuccess(response.data)
//       );

//       yield safeResolveAsync(resolve, {
//         success: true,
//         data: response.data,
//       });
//     } else {
//       const error =
//         response.statusText || "Failed to update email template";

//       yield put(actions.updateEmailTemplateFailure(error));

//       yield safeResolveAsync(resolve, {
//         success: false,
//         error,
//       });
//     }
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.error ||
//       error.message ||
//       "Something went wrong";

//     yield put(actions.updateEmailTemplateFailure(errorMessage));

//     yield safeResolveAsync(resolve, {
//       success: false,
//       error: errorMessage,
//     });
//   }
// }

// /* =========================
//    SEND TEST EMAIL
// ========================= */

// function* sendTestEmailSaga({ payload, resolve }) {
//   try {
//     yield put(actions.sendTestEmailRequest());

//     const response = yield call(
//       sendTestEmail,
//       payload
//     );

//     if (response.status === OK || response.status === CREATED) {
//       yield put(
//         actions.sendTestEmailSuccess(response.data)
//       );

//       yield safeResolveAsync(resolve, {
//         success: true,
//         data: response.data,
//       });
//     } else {
//       const error =
//         response.statusText || "Failed to send test email";

//       yield put(actions.sendTestEmailFailure(error));

//       yield safeResolveAsync(resolve, {
//         success: false,
//         error,
//       });
//     }
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.error ||
//       error.message ||
//       "Something went wrong";

//     yield put(actions.sendTestEmailFailure(errorMessage));

//     yield safeResolveAsync(resolve, {
//       success: false,
//       error: errorMessage,
//     });
//   }
// }

// /* =========================
//    ROOT SAGA
// ========================= */

// export default function* saga() {
//   yield takeLatest(
//     types.GET_EMAIL_TEMPLATES,
//     getEmailTemplatesSaga
//   );

//   yield takeLatest(
//     types.CREATE_EMAIL_TEMPLATE,
//     createEmailTemplateSaga
//   );

//   yield takeLatest(
//     types.UPDATE_EMAIL_TEMPLATE,
//     updateEmailTemplateSaga
//   );

//   yield takeLatest(
//     types.SEND_TEST_EMAIL,
//     sendTestEmailSaga
//   );
// }

import { call, put, takeLatest } from "redux-saga/effects";
import { actions, types } from "./duck";

import {
  getEmailTemplates,
  createEmailTemplate,
  updateEmailTemplate,
  sendTestEmail,
  sendEmails,
} from "./api";

import { OK, CREATED, ACCEPTED } from "http-status-codes";
import { safeResolveAsync } from "../../../utils";

/* =========================
   GET EMAIL TEMPLATES
========================= */

function* getEmailTemplatesSaga({ resolve }) {
  try {
    yield put(actions.getEmailTemplatesRequest());

    const response = yield call(getEmailTemplates);

    if (response.status === OK) {
      yield put(actions.getEmailTemplatesSuccess(response.data));

      yield safeResolveAsync(resolve, {
        success: true,
        data: response.data,
      });
    } else {
      const error =
        response.statusText || "Failed to fetch email templates";

      yield put(actions.getEmailTemplatesFailure(error));

      yield safeResolveAsync(resolve, {
        success: false,
        error,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.message ||
      "Something went wrong";

    yield put(actions.getEmailTemplatesFailure(errorMessage));

    yield safeResolveAsync(resolve, {
      success: false,
      error: errorMessage,
    });
  }
}

/* =========================
   CREATE EMAIL TEMPLATE
========================= */

function* createEmailTemplateSaga({ payload, resolve }) {
  try {
    yield put(actions.createEmailTemplateRequest());

    const response = yield call(
      createEmailTemplate,
      payload
    );

    if (response.status === CREATED || response.status === OK) {
      yield put(
        actions.createEmailTemplateSuccess(response.data)
      );

      yield safeResolveAsync(resolve, {
        success: true,
        data: response.data,
      });
    } else {
      const error =
        response.statusText || "Failed to create email template";

      yield put(actions.createEmailTemplateFailure(error));

      yield safeResolveAsync(resolve, {
        success: false,
        error,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.message ||
      "Something went wrong";

    yield put(actions.createEmailTemplateFailure(errorMessage));

    yield safeResolveAsync(resolve, {
      success: false,
      error: errorMessage,
    });
  }
}

/* =========================
   UPDATE EMAIL TEMPLATE
========================= */

function* updateEmailTemplateSaga({
  id,
  payload,
  resolve,
}) {
  try {
    yield put(actions.updateEmailTemplateRequest());

    const response = yield call(
      updateEmailTemplate,
      id,
      payload
    );

    if (response.status === OK) {
      yield put(
        actions.updateEmailTemplateSuccess(response.data)
      );

      yield safeResolveAsync(resolve, {
        success: true,
        data: response.data,
      });
    } else {
      const error =
        response.statusText || "Failed to update email template";

      yield put(actions.updateEmailTemplateFailure(error));

      yield safeResolveAsync(resolve, {
        success: false,
        error,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.message ||
      "Something went wrong";

    yield put(actions.updateEmailTemplateFailure(errorMessage));

    yield safeResolveAsync(resolve, {
      success: false,
      error: errorMessage,
    });
  }
}

/* =========================
   SEND TEST EMAIL
========================= */

function* sendTestEmailSaga({ payload, resolve }) {
  try {
    yield put(actions.sendTestEmailRequest());

    const response = yield call(
      sendTestEmail,
      payload
    );

    if (response.status === OK || response.status === CREATED) {
      yield put(
        actions.sendTestEmailSuccess(response.data)
      );

      yield safeResolveAsync(resolve, {
        success: true,
        data: response.data,
      });
    } else {
      const error =
        response.statusText || "Failed to send test email";

      yield put(actions.sendTestEmailFailure(error));

      yield safeResolveAsync(resolve, {
        success: false,
        error,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      error.message ||
      "Something went wrong";

    yield put(actions.sendTestEmailFailure(errorMessage));

    yield safeResolveAsync(resolve, {
      success: false,
      error: errorMessage,
    });
  }
}

/* =========================
   SEND EMAIL
========================= */

function* sendEmailSaga({ payload, resolve }) {
  try {
    yield put(actions.sendEmailRequest());

    const response = yield call(
      sendEmails,
      payload
    );

    if (response.status === ACCEPTED) {
      yield put(
        actions.sendEmailSuccess(response.data)
      );

      yield safeResolveAsync(resolve, {
        success: true,
        data: response.data,
      });
    } else {
      const error =
        response.statusText || "Failed to send email";

      yield put(actions.sendEmailFailure(error));

      yield safeResolveAsync(resolve, {
        success: false,
        error,
      });
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.detail ||
      error.response?.data?.error ||
      error.message ||
      "Something went wrong";

    yield put(actions.sendEmailFailure(errorMessage));

    yield safeResolveAsync(resolve, {
      success: false,
      error: errorMessage,
    });
  }
}

/* =========================
   ROOT SAGA
========================= */

export default function* saga() {
  yield takeLatest(
    types.GET_EMAIL_TEMPLATES,
    getEmailTemplatesSaga
  );

  yield takeLatest(
    types.CREATE_EMAIL_TEMPLATE,
    createEmailTemplateSaga
  );

  yield takeLatest(
    types.UPDATE_EMAIL_TEMPLATE,
    updateEmailTemplateSaga
  );

  yield takeLatest(
    types.SEND_TEST_EMAIL,
    sendTestEmailSaga
  );

  yield takeLatest(
    types.SEND_EMAIL,
    sendEmailSaga
  );
}